import proj4 from 'proj4';
import { register } from 'ol/proj/proj4';

// 좌표계 정의: 필요 시 확장
const defs = {
    'EPSG:5174': '+proj=tmerc +lat_0=38 +lon_0=127 +k=0.9996 +x_0=1000000 +y_0=2000000 +ellps=GRS80 +units=m +no_defs',
    'EPSG:5186': '+proj=tmerc +lat_0=38 +lon_0=127 +k=1 +x_0=200000 +y_0=600000 +ellps=GRS80 +units=m +no_defs',
    'EPSG:5187': '+proj=tmerc +lat_0=38 +lon_0=129 +k=1 +x_0=200000 +y_0=600000 +ellps=GRS80 +units=m +no_defs',
};

Object.entries(defs).forEach(([code, def]) => {
    if (!proj4.defs[code]) {
        proj4.defs(code, def);
    }
});

register(proj4);
